// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ikKCq","type":"styles_type__2dzlO","choices":"styles_choices__2nx9T"};